import axiosUtil from "../js/utils/AxiosUtils.js";

const actions = {
    getClientH: function ({ commit }, clientH) {//获取可视区域高度
        commit("" +
            "", clientH);
    },
    changeSideItem({ commit  }, sideItemName){//点击侧边栏
        commit("CHANGE_SIDE_ITEM", sideItemName);
    },
    getAmplifyImageArr({ commit }, imageObj){// 获取需要放大的图片数组
        commit("GET_AMPLIFY_IMAGE_ARR", imageObj);
    },
    /*对话模块*/
    getUserInfo({ commit }, loginInfo){//点击登陆按钮获取用户信息
        commit("GET_USER_INFO", loginInfo);
    },
    getPatientId({ commit }, patientId){//获取点击的患者ID
        commit("GET_PATIENT_ID", patientId);
    },
    getMsgList({ commit }, consultId){// 根据consultId获取聊天数据
        let options = {
            pageNo: 1,
            pageSize: 10000,
            consultId: consultId,
            token: localStorage.getItem("token"),
            Service: "nethos.consult.message.list"
        };
        axiosUtil(options, function(data){
            commit("GET_MESSAGE_LIST", data.list);
        });
    },
    getPatMsgList({ commit }, followId, pageNo=1){// 根据consultId获取聊天数据
        let options = {
            followId: followId,
            pageSize: 20,
            pageNo: pageNo,
            token: localStorage.getItem("token"),
            Service: "nethos.follow.message.detail.list"
        };
        axiosUtil(options, function(data){
            commit("GET_PAT_MESSAGE_LIST", data);
        });
    },
    getPushMsgConsultId({ commit }, pushMsgConsultId){// 聊天回复推送的consultId
        commit("GET_PUSH_MSG_CONSULT_ID", pushMsgConsultId);
    },
    getPushMsgFollowId({ commit }, pushMsgFollowId){// 医患关系聊天回复推送的followId
        commit("GET_PUSH_MSG_FOLLOW_ID", pushMsgFollowId);
    },
    /*远程会诊模块*/
    getCurrentConsultList({ commit }, list){//获取当前会诊列表
        commit("GET_CURRENT_CONSULT_LIST", list);
    },
    getCurrentConsult({ commit }, consultId){//获取当前操作的会诊单使子路由能够使用
        commit("GET_CURRENT_CONSULT", currentConsult);
    },
    getConsultType({ commit }, consultType){//获取发起会诊类型
        commit("GET_CONSULT_TYPE", consultType);
    },
    getInviteDocList({ commit }, inviteVoList){//获取邀请视频医生列表
        commit("GET_INVITE_DOC_LIST", inviteVoList);
    },
    getSideBarTitle({ commit }, title){//获取医助端问会诊侧边栏列表顶部标题
        commit("GET_SIDEBAR_TITLE", title);
    },
    getPrintDetail({ commit }, detail){// 获取需要打印的会诊单详情
        commit("GET_PRINT_DETAIL", detail);
    },
    /*设置*/
    //个人业务设置
    /*setBusSettingVideoState({ commit }, setting){//是否开通视频问诊
        commit("SET_BUSINESS_SETTING_VIDEO_STATE", setting);
    },
    setBusSettingVideoPrice({ commit }, price){//视频问诊费用
        commit("SET_BUSINESS_SETTING_VIDEO_PRICE", price);
    },*/
    setBusSettingVideoMove({ commit }, move){//视频问诊开通滑块
        commit("SET_BUSINESS_SETTING_VIDEO_MOVE", move)
    },
    setBusSettingPicMove({ commit }, move){//图文咨询开通滑块
        commit("SET_BUSINESS_SETTING_PIC_MOVE", move)
    },
    getSetUpClickName({commit}, setUpClickName){
        commit("GET_SET_UP_CLICK_NAME", setUpClickName);
    },
    /*setBusSettingPicState({ commit }, setting){//是否开通图文咨询
        commit("SET_BUSINESS_SETTING_PIC_STATE", setting);
    },
    setBusSettingPicPrice({ commit }, price){//图文咨询费用
        commit("SET_BUSINESS_SETTING_PIC_PRICE", price);
    },*/
 //绑定手机号修改

    /*我的患者模块*/
    getPatDetail({ commit }, patDetail){//获取点击的患者详情
        commit("GET_PAT_DETAIL", patDetail);
    },
    getPatId({ commit }, patId){//获取点击的患者id
        commit("GET_PAT_ID", patId);
    },
    getMedicalHistoryItem({ commit },sysMedicalHistroyItem){//获取需要编辑修改的诊疗记录项
        commit("GET_MEDICAL_HISTORY_ITEM", sysMedicalHistroyItem);
    },
    getMedicalEditType({ commit }, editType){//获取上传诊疗记录弹出窗类型
        commit("GET_MEDICAL_EDIT_TYPE", editType);
    },
    getCheckFollowIdList({ commit }, checkFollowList){//我的患者群发消息时，所选择的患者
        commit("CHECK_FOLLOW_ID_LIST", checkFollowList);
    },
    getPushPointMyPatientArr({ commit }, pushPointFollowId){// 当前推送的会话聊天followId数组(会有多个聊天推送), 用于显示列表中的红点
        commit("GET_PUSH_POINT_MY_PATIENT_ARR", pushPointFollowId);
    },
    removePushPointMyPatientArr({ commit }, removePointFollowId){// 左侧聊天列表中点击某项，删除红点
        commit("REMOVE_PUSH_POINT_MY_PATIENT_ARR", removePointFollowId);
    },
    /*文章发布模块*/
    getArticleList({ commit }, articleList){//获取文章列表
        commit("GET_ARTICLE_LIST", articleList);
    },
    isOpenArticleListBox({ commit }, isOpenArticleListBox){// 是否打开发送文章列表
        commit("IS_OPEN_ARTICLE_LIST_BOX", isOpenArticleListBox);
    },
    /*图文咨询模块*/
    getCurrentPatientTab({ commit }, tabName){// 获取当前点击列表处理按钮所在tab页码
        commit("GET_CURRENT_PATIENT_TAB", tabName);
    },

    /**
     * 推送模块
     */
    enterVideoList({commit},enterVideoList){//进入视频的会诊单ID列表
        commit("ENTER_VIDEO_LIST", enterVideoList);
    },
    enterVideoDdid({commit},enterVideoDdid){//进入视频订单id
        commit("ENTER_VIDEO_DDID",enterVideoDdid);
    },
    isOpenMsgListBox({ commit }, isOpenMsgListBox) {// 是否打开消息盒子
         commit("IS_OPEN_MSG_LIST_BOX", isOpenMsgListBox);
    },
    isGetNewMsg_yqys({ commit }, isGetNewMsg_yqys){// 邀请医生
        commit("IS_GET_NEW_MSG_YQYS", isGetNewMsg_yqys);
    },
    getAllMsgBoxList({ commit }, pageNo=1) {// 获取所有消息列表
        // let options = {
        //     pageNo: pageNo,
        //     pageSize: 10,
        //     token: localStorage.getItem("token"),
        //     Service: "nethos.system.messagebox.list"
        // };
        // axiosUtil(options, function(data){
        //     console.log("77/77777",data);
        //     commit("GET_ALL_MSG_BOX_LIST", data);
        // });
    },
    getAllMsgBoxListCounts({ commit }) {// 获取所有消息数

        // let options = {
        //     token: localStorage.getItem("token"),
        //     Service: "nethos.system.messagebox.noread.count"
        // };
        // axiosUtil(options, function(data){//更新总数据
        //     commit("GET_ALL_MSG_BOX_LIST_COUNTS", data.obj);
        // });
    },
    changeMsgBoxListCounts({ commit }, isAdd) {// 增加消息数, 加1或者减1
        /*let options = {
            token: localStorage.getItem("token"),
            Service: "nethos.system.messagebox.list"
        };
        axiosUtil(options, function(data){//更新总数据
            actions.getAllMsgBoxList({ commit }, data);
          //  actions.getAllMsgBoxListCounts({ commit }, data.list.length);
        });*/
        //actions.getAllMsgBoxList({ commit }, 1);//更新消息盒子列表数据
        commit("CHANGE_MSG_BOX_LIST_COUNTS", isAdd);
    },
    getEndConsultId({ commit }, endConsultId) {//获取当前结束的问会诊id
        commit("GET_END_CONSULT_ID", endConsultId);
    },
    getRefreshConsultId({ commit }, refreshConsultId){// 获取当前需要刷新的id
        commit("GET_REFRESH_CONSULT_ID", refreshConsultId);
    },
    //图文咨询
    isGetNewMsg_twzx({ commit }, isGetNewMsg_twzx){// 图文咨询侧边栏红点
        commit("IS_GET_NEW_MSG_TWZX", isGetNewMsg_twzx);
    },
    isGetNewMsg_twzx_dcl({ commit }, isGetNewMsg_twzx_dcl){//获取图文咨询是否有新消息
        commit("IS_GET_NEW_MSG_TWZX_DCL", isGetNewMsg_twzx_dcl);
    },
    isGetNewMsg_twzx_dhf({ commit }, isGetNewMsg_twzx_dhf){//获取图文咨询是否有新待回复
        commit("IS_GET_NEW_MSG_TWZX_DHF", isGetNewMsg_twzx_dhf);
    },
    isGetNewMsg_twzx_ywc({ commit }, isGetNewMsg_twzx_ywc){//获取图文咨询已结束是否有新消息
        commit("IS_GET_NEW_MSG_TWZX_YWC", isGetNewMsg_twzx_ywc);
    },
    isGetNewMsg_twzx_yqx({ commit }, isGetNewMsg_twzx_yqx){//获取图文咨询已取消是否有新消息
        commit("IS_GET_NEW_MSG_TWZX_YQX", isGetNewMsg_twzx_yqx);
    },
    //我的患者
    isGetNewMsg_wdhz({ commit }, isGetNewMsg_wdhz){// 我的患者侧边栏红点
        commit("IS_GET_NEW_MSG_WDHZ", isGetNewMsg_wdhz);
    },
    //视频问诊
    isGetNewMsg_spwz({ commit }, isGetNewMsg_spwz){// 视频问诊侧边栏红点
        commit("IS_GET_NEW_MSG_SPWZ", isGetNewMsg_spwz);
    },
    isGetNewMsg_spwz_dcl({ commit }, isGetNewMsg_spwz_dcl){//获取视频问诊是否有新消息
        commit("IS_GET_NEW_MSG_SPWZ_DCL", isGetNewMsg_spwz_dcl);
    },
    isGetNewMsg_spwz_bczl({ commit }, isGetNewMsg_spwz_bczl){//获取视频问诊补充资料推送
        commit("IS_GET_NEW_MSG_SPWZ_BCZL", isGetNewMsg_spwz_bczl);
    },
    isGetNewMsg_spwz_dwz({ commit }, isGetNewMsg_spwz_dwz){//获取视频问诊待问诊推送
        commit("IS_GET_NEW_MSG_SPWZ_DWZ", isGetNewMsg_spwz_dwz);
    },
    isGetNewMsg_spwz_ywc({ commit }, isGetNewMsg_spwz_ywc){// 完成视频问诊推送
        commit("IS_GET_NEW_MSG_SPWZ_YWC", isGetNewMsg_spwz_ywc);
    },
    isGetNewMsg_spwz_yqx({ commit }, isGetNewMsg_spwz_yqx){// 取消视频问诊推送
        commit("IS_GET_NEW_MSG_SPWZ_YQX", isGetNewMsg_spwz_yqx);
    },

    //远程会诊
    isGetNewMsg_ychz({ commit }, isGetNewMsg_ychz){// 视频问诊侧边栏红点
        commit("IS_GET_NEW_MSG_YCHZ", isGetNewMsg_ychz);
    },
    isGetNewMsg_ychz_wfq({ commit }, isGetNewMsg_ychz_wfq){//获取发起会诊
        commit("IS_GET_NEW_MSG_YCHZ_WFQ", isGetNewMsg_ychz_wfq);
    },
    isGetNewMsg_ychz_wsd({ commit }, isGetNewMsg_ychz_wfq){//获取收到会诊
        commit("IS_GET_NEW_MSG_YCHZ_WSD", isGetNewMsg_ychz_wfq);
    },
    isGetNewMsg_ychz_ywc({ commit }, isGetNewMsg_ychz_ywc){//获取已完成会诊
        commit("IS_GET_NEW_MSG_YCHZ_YWC", isGetNewMsg_ychz_ywc);
    },
    isGetNewMsg_ychz_yqx({ commit }, isGetNewMsg_ychz_yqx){//获取已完成会诊
        commit("IS_GET_NEW_MSG_YCHZ_YQX", isGetNewMsg_ychz_yqx);
    },
    isGetNewMsg_ychz_bczl({ commit }, isGetNewMsg_ychz_bczl){// 补充了资料推送
        commit("IS_GET_NEW_MSG_YCHZ_BCZL", isGetNewMsg_ychz_bczl);
    },
    isGetNewMsg_ychz_yqbc({ commit }, isGetNewMsg_ychz_yqbc){// 要求补充资料推送
        commit("IS_GET_NEW_MSG_YCHZ_YQBC", isGetNewMsg_ychz_yqbc);
    },
    /*会议中心*/
    getRefreshMtId({ commit }, refreshMtId){// 获取当前需要刷新的id
        commit("GET_REFRESH_MT_ID", refreshMtId);
    },
    //会议中心
    isGetNewMsg_hyzx({ commit }, isGetNewMsg_hyzx){// 视频问诊侧边栏红点
        commit("IS_GET_NEW_MSG_HYZX", isGetNewMsg_hyzx);
    },
    isGetNewMsg_hyzx_dcj({ commit }, isGetNewMsg_hyzx_dcj){//获取发起会诊
        commit("IS_GET_NEW_MSG_HYZX_DCJ", isGetNewMsg_hyzx_dcj);
    },
    isGetNewMsg_hyzx_lshy({ commit }, isGetNewMsg_hyzx_lshy){//获取发起会诊
        commit("IS_GET_NEW_MSG_HYZX_LSHY", isGetNewMsg_hyzx_lshy);
    },

};
export default actions;
